export default __webpack_public_path__ + "14c647e949faaea466eb5de7b9a122b4.png";